import 'classlist-polyfill'
import 'promise-polyfill/src/polyfill'

import React, { FC, useState, useEffect, useCallback } from 'react'
import Chart from "react-apexcharts"
import { useTranslation } from 'react-i18next'

import { chartOptions as initialChartOptions } from './VariablesCategoryWork'
import Loading from '../common/Loading'

import { MemberReportCategoryWork } from '../../../states/types/member'
import { map, uniqueId } from 'lodash'
import { convertHexColor } from '../../../utils/color'
import InfoTips from '../common/InfoTips'

interface CategoryWorkTimeProps {
  isLoading: boolean | undefined
  categoryWork: MemberReportCategoryWork | undefined
  setCategoryFilter: (categoryFilter: string) => void
  mode: "daily" | "monthly" | "custom"
}

const CategoryWorkTime: FC<CategoryWorkTimeProps> = (props) => {
  const { t } = useTranslation()

  const {
    isLoading,
    categoryWork,
    setCategoryFilter,
    mode,
  } = props

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [chartData, setChartData] = useState<any>(undefined)

  useEffect(() => {
    if (!categoryWork) return
    const chartOptions = initialChartOptions
    chartOptions.xaxis.categories = map(categoryWork.work_time.labels, (label) => t(`parts.category_name.${label}`))
    chartOptions.colors = [({ dataPointIndex }: { dataPointIndex: number }) => {
      const colors = categoryWork.work_time.colors.map((value) => convertHexColor(value, 0.8))
      return colors[dataPointIndex]
    }, "#C4C4C4"] as never[]
    setChartData({
      series: [
        { name: "現在", data: categoryWork?.work_time.work_time.now },
        { name: "過去", data: categoryWork?.work_time.work_time.past },
      ],
      option: {
        ...chartOptions,
        xaxis: {
          ...chartOptions.xaxis,
        },
      },
    })
  }, [categoryWork])

  const applicationRef = useCallback((node: HTMLInputElement | null) => {
    if (!node) return
    $(node).on('click', ".apexcharts-series", (event) => {
      if (!chartData) return
      setCategoryFilter(chartData.option.xaxis.categories[Number(event.target.getAttribute("j"))])
    })
  }, [chartData])

  const calcWidth = (index: number) => {
    if (index === 0 || index === 3 || index === 6) {
      return "14%"
    }
    return "13%"
  }

  const buildPositiveNegativeIcon = (value: number) => (value >= 0 ? "/static/images/report/icon_up.svg" : "/static/images/report/icon_down.svg")

  const compareText = (type: string) => {
    if (type === "daily") {
      return (
        `(${t("parts.category_work_time.compare_daily")})`
      )
    }
    if (type === "monthly") {
      return (
        `(${t("parts.category_work_time.compare_monthly")})`
      )
    }
    return (
      `(${t("parts.category_work_time.compare_past")})`
    )
  }

  return (
    <div style={{ marginLeft: "0.5em", marginRight: "0.5em" }}>
      <div className="box">
        <div style={{ paddingTop: "1em", textAlign: "center" }}>
          <span style={{ fontSize: "24px", fontWeight: "bold", color: "#094E8D" }}>{t("parts.category_work_time.title")}</span>
        </div>
        <InfoTips>
          <>
            <div>
              アプリケーションを分類別に集計し、表示しています
            </div>
          </>
        </InfoTips>
        <div className="flex" style={{ paddingTop: "1em", justifyContent: "center", alignItems: "center" }}>
          <div style={{ width: "1em", height: "0.25em", background: "#C4C4C4", borderRadius: "10px" }} />
          <span style={{ paddingLeft: "0.25em", fontSize: "12px" }}>
            {
              mode === "monthly" ? (
                <>{t("parts.category_work_time.past_time_caption_monthly")}</>
              ) : (
                <>{t("parts.category_work_time.past_time_caption_daily")}</>
              )
            }
          </span>
        </div>
        {
          (isLoading || !chartData || !categoryWork) ? (
            <Loading />
          ) : (
            <>
              <div ref={applicationRef}>
                <Chart
                  options={chartData.option}
                  type="bar"
                  series={chartData.series}
                  height="350px"
                />
              </div>
              <div className="flex" style={{ width: "100%", marginLeft: "3.5em", paddingBottom: "1em" }}>
                {
                  categoryWork?.biz.map((item, index) => (
                    <div key={uniqueId()} style={{ width: calcWidth(index), textAlign: "center" }}>
                      <div>
                        <span style={{ fontWeight: "bold", color: "rgba(51, 51, 51, 0.8)" }}>
                          {item.target.toLocaleString()}
                          &nbsp;
                          biz
                        </span>
                      </div>
                      <div style={{ paddingTop: "0.25em", display: "table", margin: "auto" }}>
                        <img className="positive_negative_icon" src={buildPositiveNegativeIcon(item.compare)} alt="positive_negative_icon" />
                        <span className={item.compare >= 0 ? 'compare_plus' : 'compare_minus'}>
                          {item.compare}
                          %
                        </span>
                      </div>
                      <div style={{ paddingTop: "0.25em" }}>
                        <span style={{ color: "rgba(51, 51, 51, 0.75)" }}>
                          {compareText(mode)}
                        </span>
                      </div>
                    </div>
                  ))
                }
              </div>
            </>
          )
        }
      </div>
    </div>
  )
}

export default CategoryWorkTime
